// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiFamily {
    static getAttributeTypeMap() {
        return PharmacyBiFamily.attributeTypeMap;
    }
}
PharmacyBiFamily.discriminator = undefined;
PharmacyBiFamily.additionalProperties = false;
PharmacyBiFamily.attributeTypeMap = [
    {
        "name": "deductibleExists",
        "baseName": "deductibleExists",
        "type": "string"
    },
    {
        "name": "deductibleMet",
        "baseName": "deductibleMet",
        "type": "string"
    },
    {
        "name": "deductibleTotal",
        "baseName": "deductibleTotal",
        "type": "string"
    },
    {
        "name": "oopMaximum",
        "baseName": "oopMaximum",
        "type": "string"
    },
    {
        "name": "oopMaximumExists",
        "baseName": "oopMaximumExists",
        "type": "string"
    },
    {
        "name": "oopMet",
        "baseName": "oopMet",
        "type": "string"
    },
    {
        "name": "unitNumber",
        "baseName": "unitNumber",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiFamily.js.map